// GetPageMetaData returns the meta data for the similar products page
export const ProductRecommendationsMetaService_GetPageMetaDataLazy = () =>
  import("./service.grpc").then(
    (m) => m.ProductRecommendationsMetaService_GetPageMetaData
  );
ProductRecommendationsMetaService_GetPageMetaDataLazy.method =
  "aysa_api.services.product_recommendations_page.v1.meta.ProductRecommendationsMetaService/GetPageMetaData" as const;
